export default __webpack_public_path__ + "static/media/prize-2.3772f75a.webp";